export default {
  allBills: [],
}
